import React from "react";
import Transactions from "../components/Transactions/Transactions";

export default function TransactionPage() {
  return <Transactions />;
}
